var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M23 15.01c0-.42-.222-.805-.572-1.038L13.667 8.5V2.083c0-.968-.782-1.75-1.75-1.75-.969 0-1.75.782-1.75 1.75V8.5l-8.762 5.472a1.224 1.224 0 0 0 1.015 2.205l7.747-2.427v6.417l-2.1 1.575a.56.56 0 0 0-.234.466v.689c0 .385.374.665.747.56l3.337-.957 3.336.957a.587.587 0 0 0 .747-.56v-.689a.56.56 0 0 0-.233-.466l-2.1-1.575V13.75l7.746 2.427A1.224 1.224 0 0 0 23 15.01z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightPath);
export default __webpack_public_path__ + "static/media/flight-path.8ed4fd3ecf6ef2c5993c01073ca78646.svg";
export { ForwardRef as ReactComponent };